import { HttpParams } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NbDialogService } from "@nebular/theme";
import { NotificationsService } from "angular2-notifications";
import { NgxSpinnerService } from "ngx-spinner";
import { ModalAcaoComponent } from "../../../../shared/importacao-lote/components/modals/modal-acao/modal-acao.component";
import { EColumnType } from "../../../../shared/importacao-lote/components/table/EColumnType";
import { EImportacaoType } from "../../../../shared/importacao-lote/components/table/EImportacaoType";
import { IEnderecoDetalhes } from "../../../../shared/importacao-lote/dto/IEnderecoDetalhes";
import { ILoteDetalhes } from "../../../../shared/importacao-lote/dto/ILoteDetalhes";
import { EAcaoType } from "../../../../shared/importacao-lote/enums/EAcaoType";
import cancelarImportacaoLote from "../../../../shared/importacao-lote/utils/cancelar-importacao";
import { FilterService } from "../../../../shared/importacao-lote/utils/filter.service";
import { mapEnumToLabelObject } from "../../../../shared/importacao-lote/utils/mapEnumToLabelObject";
import { FormField } from "../../../../shared/interfaces/FormField";
import { HttpService } from "../../../../shared/services/http/http-client.service";
import {
  EStatusItemLoteEnum,
  StatusItemLoteMap,
} from "../../enums/EStatusItemLoteEnum";
import {
  EStatusLoteFuncionarioEnum,
  StatusLoteFuncionarioMap,
} from "../../enums/EStatusLoteFuncionarioEnum";

export enum EStatusItemLoteAux {
  CRIANDO_CADASTRO = "Criando cadastro",
  CRIANDO_CARTAO = "Criando cartão",
  CRIANDO_ACESSO = "Criando acesso",
  ERRO_CADASTRO = "Erro cadastro",
  ERRO_CARTAO = "Erro cartão",
  ERRO_ACESSO = "Erro acesso",
  PROCESSADO_COM_SUCESSO = "Cadastrado com sucesso",
}

const StatusItemLoteMapAux = {
  ["CRIANDO_CADASTRO"]: { label: "Criando cadastro" },
  ["CRIANDO_CARTAO"]: { label: "Criando cartão" },
  ["CRIANDO_ACESSO"]: { label: "Criando acesso" },
  ["ERRO_CADASTRO"]: { label: "Erro cadastro" },
  ["ERRO_CARTAO"]: { label: "Erro cartão" },
  ["ERRO_ACESSO"]: { label: "Erro acesso" },
  ["PROCESSADO_COM_SUCESSO"]: { label: "Cadastrado com sucesso" },
};

@Component({
  selector: "ngx-importacao-finalizada-lote",
  templateUrl: "./importacao-finalizada.component.html",
  styleUrls: ["./importacao-finalizada.component.scss"],
})
export class ImportacaoFinalizadaComponent implements OnInit {
  public loteId: number = null;
  public filters: HttpParams = new HttpParams();
  public breadcrumbPath;
  public loteDetalhes: ILoteDetalhes = null;
  public urlLembrete = null;
  public urlGet = null;
  public enumLote = EStatusLoteFuncionarioEnum;
  public enumLoteMap = StatusLoteFuncionarioMap;
  public enumItem = EStatusItemLoteEnum;
  public enumItemMap = StatusItemLoteMap;
  public infoLote = [];
  public cargaFormFields: FormField[] = [];
  public titleButton = "CANCELAR";
  public EImportacaoType = EImportacaoType.FUNCIONARIO;
  public pathToGoBack: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private http: HttpService,
    private readonly filterService: FilterService,
    private dialogService: NbDialogService,
    private notifications: NotificationsService,
    private spinnerService: NgxSpinnerService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParamMap.subscribe((params: any) => {
      this.loteId = params.params.loteId;
    });

    this.breadcrumbPath = [{ label: "Lote ID " + this.loteId }];
    this.urlLembrete = `/importacao-funcionario/${this.loteId}/itens-lote-funcionario/erro-validacao`;
    this.urlGet = `/importacao-funcionario/${this.loteId}/itens-lote`;

    this.setFormFields();

    this.pathToGoBack =
      ((this.router && this.router.url && this.router.url.split("/")[2]) ||
        "") + "/importacao-lote";
    this.filter({});
    this.getDados();
  }

  public tableColumns = [
    { prop: "", name: "", type: EColumnType.MODAL },
    { prop: "nome", name: "Nome", type: EColumnType.STRING },
    { prop: "cpf", name: "CPF", type: EColumnType.CPF_CNPJ },
    { prop: "matricula", name: "Matrícula", type: EColumnType.STRING },
    { prop: "email", name: "E-mail", type: EColumnType.STRING },
    { prop: "codigoCentroDeCusto", name: "Centro de Custo", type: EColumnType.STRING },
    { prop: "status", name: "Status Importação", type: EColumnType.ENUM },
  ];

  setInfoLote() {
    this.infoLote = [
      {
        title: "Nome do arquivo",
        value: this.loteDetalhes.nomeArquivo,
        type: EColumnType.STRING,
      },
      {
        title: "Data de criação",
        value: this.loteDetalhes.dataCadastro,
        type: EColumnType.DATE,
      },
      {
        title: "Erros cadastro",
        value: this.loteDetalhes.qtdErros,
        type: EColumnType.NUMBER,
      },
      {
        title: "Total cadastrado",
        value:
          (this.loteDetalhes.qtdImportada || 0) -
          (this.loteDetalhes.qtdErros || 0),
        type: EColumnType.NUMBER,
      },
      {
        title: "Status",
        value: this.loteDetalhes.status,
        type: EColumnType.ENUM,
      },
      {
        title: "Tipo",
        value: this.loteDetalhes.tipo,
        type: EColumnType.STRING,
      },
    ];

    if (this.loteDetalhes.tipo.toLowerCase() === "nominal") {
      this.infoLote.push(
        {
          title: "Quantidade de cartões",
          value: this.loteDetalhes.qtdCartoes,
          type: EColumnType.NUMBER,
        },
        {
          title: "Valor da unidade",
          value: this.loteDetalhes.valorUnidade || 0,
          type: EColumnType.CURRENCY,
        },
        {
          title: "Total do pedido cartões",
          value:
            (this.loteDetalhes.valorUnidade || 0) *
            (this.loteDetalhes.qtdCartoes || 0),
          type: EColumnType.CURRENCY,
        },
        {
          title: "ENDEREÇO ENTREGA",
          value: () => this.showModalEnderecoEntrega(),
          type: EColumnType.ACTION,
        }
      );
    }
  }

  setFormFields() {
    let emitirCartao: boolean;
    if (this.loteDetalhes) {
      emitirCartao = this.loteDetalhes.tipo.toLowerCase() === "nominal";
    } else {
      emitirCartao = false;
    }

    this.cargaFormFields = [
      {
        name: "nome",
        label: "Nome",
        placeholder: "Digite",
        type: "text",
        value: "",
      },
      {
        name: "cpf",
        label: "CPF",
        placeholder: "Digite",
        type: "text",
        value: "",
      },
      {
        name: "matricula",
        label: "Matrícula",
        placeholder: "Digite",
        type: "text",
        value: "",
      },
      {
        name: "email",
        label: "E-mail",
        placeholder: "Digite",
        type: "text",
        value: "",
      },
      {
        name: "codigoCentroDeCusto",
        label: "Centro de Custo",
        placeholder: "Digite",
        type: "text",
        value: "",
      },
      {
        name: "status",
        label: "Status",
        placeholder: "Selecione",
        type: "select",
        value: "",
        options: mapEnumToLabelObject(
          EStatusItemLoteAux,
          StatusItemLoteMapAux
        ).filter(
          (option) =>
            // Remove opções de cartão para o módulo No Name
            emitirCartao ||
            (option.key !== "CRIANDO_CARTAO" && option.key !== "ERRO_CARTAO")
        ),
      },
    ];
  }

  showModalEnderecoEntrega() {
    // endereço de entrega
    this.spinnerService.show();
    this.http.doGet(
      `/importacao-funcionario/endereco-lote`,
      "",
      (response: IEnderecoDetalhes) => {
        this.spinnerService.hide();
        this.dialogService.open(ModalAcaoComponent, {
          closeOnBackdropClick: false,
          closeOnEsc: false,
          context: {
            data: {
              title: "Endereço de entrega",
              messageFooter:
                "Para alterar o endereço de entrega do cartão, entre em contato\ncom a central de atendimento antes de concluir o cadastro.",
              acaoType: EAcaoType.INFORMAR,
              data: [
                {
                  label: "Rua",
                  value: response.logradouro,
                  type: EColumnType.STRING,
                },
                { label: "CEP", value: response.cep, type: EColumnType.STRING },
                {
                  label: "Número",
                  value: response.numero,
                  type: EColumnType.STRING,
                },
                {
                  label: "Complemento",
                  value: response.complemento,
                  type: EColumnType.STRING,
                },
                {
                  label: "Bairro",
                  value: response.bairro,
                  type: EColumnType.STRING,
                },
                {
                  label: "Cidade",
                  value: response.localidade,
                  type: EColumnType.STRING,
                },
                {
                  label: "Estado",
                  value: response.estado,
                  type: EColumnType.STRING,
                },
              ],
            },
          },
        });
      },
      (_: any) => {
        this.spinnerService.hide();
      }
    );
  }

  getDados() {
    this.http.doGet(
      `/importacao-funcionario/${this.loteId}/detalhes-lote-funcionario`,
      "",
      (response: ILoteDetalhes) => {
        this.loteDetalhes = response;
        this.titleButton =
          response.status.toString() === "AGENDADO"
            ? "CANCELAR CARGA"
            : "CANCELAR";

        this.setFormFields();

        // caso o lote esteja finalizado, buscará o valor unitário que foi pago no momento do pagamento, e não o valor atual da tarifa
        if (
          this.loteDetalhes.status.toString() !== "FINALIZADO" &&
          this.loteDetalhes.tipo.toLowerCase() === "nominal"
        ) {
          // tarifas
          this.http.doGet(
            `/importacao-funcionario/tarifa-emissao-cartao`,
            "",
            (response) => {
              if (response.taxaEmissao) {
                this.loteDetalhes.valorUnidade = response.taxaEmissao;
              }

              this.setInfoLote();
            }
          );
        } else {
          this.setInfoLote();
        }
      }
    );
  }

  filter(event) {
    const properties = ["nome", "cpf", "matricula", "email", "codigoCentroDeCusto", "status"];
    this.filters = this.filterService.generateFilter(event, properties);
    this.getDados();
  }

  onCancel() {
    cancelarImportacaoLote(
      this.dialogService,
      this.spinnerService,
      this.notifications,
      this.router,
      this.http,
      this.loteDetalhes,
      this.EImportacaoType
    );
  }
}
